export default {
  "042104397":
    "WGBH enriches people's lives through programs and services that educate, inspire, and entertain,  fostering citizenship and culture, the joy of learning, and the power of diverse perspectives.",
  "131846366":
    "The March of Dimes is the leading nonprofit organization for pregnancy and baby health. Our  mission is to improve the health of babies by preventing birth defects, premature birth and infant mortality.",
  "363673599":
    "Feeding America’s mission is to feed America's hungry through a nationwide network of member  food banks and engage the country in the fight to end hunger.",
  "133433452":
    "MSF is an independent, international medical relief organization aiding victims of armed conflict, epidemics, natural and man-made disasters, and social marginalization.",
  "520907625":
    "NPR's mission is to work in partnership with member stations to create a more informed publicone challenged and invigorated by a deeper understanding and appreciation of events, ideas and cultures."
};



// WEBPACK FOOTER //
// ./assets/strings/charities.js